export default __webpack_public_path__ + "static/analytics-b3defadd79b057d8a17e18d996a02cac.png";